import React from 'react';
import SentDocuments from './SentDocuments';

export const SentDocumentsContext = React.createContext({});

export default SentDocuments;
